import { render, staticRenderFns } from "./WindowsMenuIcon.vue?vue&type=template&id=37ac1bcc&"
import script from "./WindowsMenuIcon.vue?vue&type=script&lang=js&"
export * from "./WindowsMenuIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports